import common from '../language/th/common.json'
import login from '../language/th/login.json'
import menu from '../language/th/menu.json'
import settings from '../language/th/settings.json'
import report from '../language/th/report.json'
import generalAdmin  from '../language/th/form.json'

export default {
    ...common,
    ...login,
    ...menu,
    ...settings,
    ...report,
    ...generalAdmin,
 
}



// WEBPACK FOOTER //
// ./src/wording/language/th.js